export const IMAGE_SIZE: number = 150 * 1000;
export const IMAGE_TYPE: string[] = ["image/jpeg", "image/jpg", "image/png"];
